import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import {
  InterviewScheduleAssignmentsCollectionNamespace,
  InterviewScheduleAssignmentsCollectionReducer,
} from './assignments-collection/assignments-collection.store';
import { InterviewSchedulesCollectionEffects } from './collection/collection.effects';
import {
  InterviewSchedulesCollectionNamespace,
  InterviewSchedulesCollectionReducer,
} from './collection/collection.store';
import { InterviewSchedulesLinkEntityEffects } from './link-entity/link-entity.effects';
import {
  InterviewSchedulesLinkEntityNamespace,
  InterviewSchedulesLinkEntityReducer,
} from './link-entity/link-entity.store';
import {
  InterviewScheduleResultRequestsCollectionNamespace,
  InterviewScheduleResultRequestsCollectionReducer,
} from './result-requests-collection/result-requests-collection.store';

@NgModule({
  imports: [
    EffectsModule.forFeature([
      InterviewSchedulesCollectionEffects,
      InterviewSchedulesLinkEntityEffects,
    ]),
    StoreModule.forFeature(
      InterviewSchedulesCollectionNamespace,
      InterviewSchedulesCollectionReducer,
    ),
    StoreModule.forFeature(
      InterviewSchedulesLinkEntityNamespace,
      InterviewSchedulesLinkEntityReducer,
    ),
    StoreModule.forFeature(
      InterviewScheduleAssignmentsCollectionNamespace,
      InterviewScheduleAssignmentsCollectionReducer,
    ),
    StoreModule.forFeature(
      InterviewScheduleResultRequestsCollectionNamespace,
      InterviewScheduleResultRequestsCollectionReducer,
    ),
  ],
})
export class InterviewSchedulesDataModule {}
